import { CotizacionVenta } from '../services/cotizacionVentaService';
import { transformarPedidoAFactura } from './pedidoToFactura';
import { PedidoVenta } from '../services/pedidoVentaService';

/**
 * Transforma una CotizacionVenta a FacturaVenta para pre-cargar datos en el formulario de facturación.
 * La cotización usa nroTipoFormulario "10"; la factura debe usar "12".
 */
export const transformarCotizacionAFactura = async (cotizacion: CotizacionVenta) => {
  const comoPedido: PedidoVenta = {
    ...cotizacion,
    nroTipoFormulario: '12', // La factura siempre usa tipo 12
  } as PedidoVenta;
  const factura = await transformarPedidoAFactura(comoPedido);
  return {
    ...factura,
    fechaVencim: cotizacion.fechaVencim ?? factura.fechaVencim ?? factura.fechaEmision,
    vtoComprob: cotizacion.vtoComprob ?? (factura as any).vtoComprob ?? null,
  };
};
